module.exports = __webpack_public_path__ + "images/sentry-loader.ecad97.svg";